// the subject "[Press Page inquiry]", its brackets percent-encoded
export const PRESS_MAILTO_HREF = 'mailto:press@change.org?subject=%5BPress%20Page%20inquiry%5D';
